// Tłumaczenie komunikatów walidacji kuponów/cart rules z PrestaShop na polski.
//
// PrestaShop (CartRule::checkValidity, classes/CartRule.php, domena
// Shop.Notifications.Error) zwraca te komunikaty przez REST po ANGIELSKU — sklep
// jest jednojęzyczny (PL), a kontekst REST nie ma załadowanych tłumaczeń tej
// domeny. Mapujemy je tu na polski w JEDNYM miejscu, używanym przez:
//   - server/api/store/cart/coupons.post.ts (aplikowanie kodu),
//   - app/utils/apiErrorMessage.ts → translateCheckoutMessage (walidacja przy checkoucie).
//
// Klucze = DOKŁADNE angielskie stringi z backendu (PrestaShop 9). Komunikat
// nierozpoznany → zwracamy oryginał, więc ewentualne już-polskie lub przyszłe
// stringi przechodzą bez zmian (brak regresji).

const VOUCHER_MESSAGE_TRANSLATIONS: Record<string, string> = {
  'This voucher is disabled': 'Ten kod rabatowy jest nieaktywny.',
  'This voucher has already been used': 'Ten kod rabatowy został już wykorzystany.',
  'This voucher is not valid yet': 'Ten kod rabatowy nie jest jeszcze ważny.',
  'This voucher has expired': 'Ten kod rabatowy wygasł.',
  'You cannot use this voucher anymore (usage limit reached)': 'Ten kod rabatowy osiągnął limit wykorzystań.',
  'You cannot use this voucher': 'Nie możesz użyć tego kodu rabatowego.',
  'You must choose a delivery address before applying this voucher to your order': 'Wybierz adres dostawy, zanim zastosujesz ten kod rabatowy.',
  'You cannot use this voucher in your country of delivery': 'Tego kodu rabatowego nie można użyć w Twoim kraju dostawy.',
  'You must choose a carrier before applying this voucher to your order': 'Wybierz metodę dostawy, zanim zastosujesz ten kod rabatowy.',
  'You cannot use this voucher with this carrier': 'Tego kodu rabatowego nie można użyć z wybraną metodą dostawy.',
  'You cannot use this voucher on products on sale': 'Tego kodu rabatowego nie można użyć na produktach w promocji.',
  'You cannot use this voucher with these products': 'Tego kodu rabatowego nie można użyć z wybranymi produktami.',
  // Złączenie z backendu: 'You cannot use this voucher' . ' - ' . 'Please log in first'
  'You cannot use this voucher - Please log in first': 'Aby użyć tego kodu rabatowego, najpierw się zaloguj.',
  'You cannot use this voucher because it has manually been removed.': 'Tego kodu rabatowego nie można użyć — został ręcznie usunięty.',
  'You cannot use this voucher in an empty cart': 'Dodaj produkt do koszyka, aby zastosować kod rabatowy.',
  // Komunikaty spoza checkValidity (kontroler /rest/cartcoupons) — zachowane
  // istniejące polskie brzmienia z dawnej mapy COUPON_ERROR_TRANSLATIONS:
  'This voucher is already in your cart': 'Ten kod rabatowy jest już aktywny w koszyku.',
  'Cart is empty': 'Dodaj produkt do koszyka, aby zastosować kod rabatowy.',
  'Coupon code does not exist.': 'Kod rabatowy nie istnieje.',
}

// Komunikaty z dynamicznym fragmentem (%s w backendzie: kwota / nazwa vouchera).
// Dopasowanie po prefiksie; builder dostaje resztę stringa po prefiksie.
const VOUCHER_MESSAGE_PREFIXES: Array<{ prefix: string, build: (rest: string) => string }> = [
  {
    // 'The minimum amount to benefit from this promo code is %s.' — zachowujemy kwotę.
    prefix: 'The minimum amount to benefit from this promo code is',
    build: rest => `Minimalna kwota do skorzystania z tego kodu rabatowego to ${rest.replace(/^\s*/, '').replace(/\.\s*$/, '')}.`,
  },
  {
    // 'This voucher is not combinable with an other voucher already in your cart: %s'
    prefix: 'This voucher is not combinable with an other voucher already in your cart',
    build: () => 'Tego kodu rabatowego nie można łączyć z innym kodem już dodanym do koszyka.',
  },
]

/**
 * Tłumaczy komunikat walidacji vouchera z PrestaShop na polski.
 * Nierozpoznany komunikat (lub już polski) zwracany jest w oryginale.
 */
export function translateVoucherMessage(message: string): string {
  const trimmed = (message || '').trim()
  if (!trimmed) return message

  const exact = VOUCHER_MESSAGE_TRANSLATIONS[trimmed]
  if (exact) return exact

  for (const { prefix, build } of VOUCHER_MESSAGE_PREFIXES) {
    if (trimmed.startsWith(prefix)) {
      return build(trimmed.slice(prefix.length))
    }
  }

  return message
}
